import styled from 'styled-components';

export const AppContainer = styled.div`
  .print-wrapper [data-is-stitched="false"], .print-wrapper [data-is-stitched="false"] {
      background-color: #000 !important;    /* Styles */
    }
`;
